import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  Join,
  JustifyContent,
  Label1,
  Space,
  colors,
} from '@gousto-internal/citrus-react'
import React from 'react'

import { DiscountBadgeOrderTabIcon } from '../iconComponents/DiscountBadgeOrderTabIcon'
import { OrderTabIcon } from './OrderTabIcon'
import type { OrderTabItemProps } from './OrderTabItem.types'
import { getOrderTabTestId } from './OrderTabs.utils'

export function OrderTabItem({ index, onActivate, tab }: OrderTabItemProps) {
  const { date_title, discount, icon, isActive } = tab

  if (!date_title || !icon) {
    throw new Error('Order tab date_title and icon are required')
  }

  const testIdSuffix = getOrderTabTestId(date_title)
  const contentColor = isActive ? Color.Secondary_400 : Color.ColdGrey_800
  const inactiveBackgroundColor = '#E0E3E6'

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onActivate(index)
    }
  }

  return (
    <Box
      data-testid="order-tab-container"
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      paddingBottom={2}
      paddingV={2}
      paddingRight={5}
      paddingH={5}
      borderWidth={0.5}
      borderStyle={BorderStyle.Solid}
      borderColor={Color.ColdGrey_100}
      role="button"
      tabIndex={0}
      aria-pressed={isActive}
      onClick={() => onActivate(index)}
      onKeyDown={handleKeyDown}
      style={{
        cursor: 'pointer',
        borderRadius: '4px',
        backgroundColor: isActive ? colors[Color.White] : inactiveBackgroundColor,
      }}
    >
      <Box
        flexGrow={1}
        data-testid={`order-tab-${testIdSuffix}`}
        display={Display.Flex}
        alignItems={AlignItems.Center}
        color={contentColor}
      >
        <Join with={<Space size={1} />}>
          <Box
            display={Display.Flex}
            alignItems={AlignItems.Center}
            justifyContent={JustifyContent.Center}
            position={DisplayPosition.Relative}
          >
            <OrderTabIcon icon={icon} isActive={isActive} />
            {discount ? (
              <Box
                color={Color.Success_800}
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
                position={DisplayPosition.Absolute}
                bottom={'12px'}
                right={'-1px'}
                width={'12px'}
                height={'12px'}
              >
                <DiscountBadgeOrderTabIcon testId="order-tab-discount-badge-icon" />
              </Box>
            ) : null}
          </Box>
        </Join>
      </Box>
      <Box flexGrow={4}>
        <Label1 color={contentColor}>{date_title}</Label1>
      </Box>
    </Box>
  )
}
